module.exports = new __parcel__URL__("cloud.923d9cf2.svg").toString();